<template>
  <div ref="progressSliderWrapper" class="media-progress-time-slider">
    <canvas
      class="buffer-zone-canvas"
      ref="bufferCanvas"
      :width="bufferCanvasWidth"
      :height="bufferCanvasHeight"
    >
    </canvas>
    <input
      class="seek-slider"
      type="range"
      ref="seekSlider"
      min="0"
      :max="duration"
      :value="currentTime"
      step="0.1"
      @mousedown="$emit('mousedown')"
      @input="onTimeSliderChange"
    />
  </div>
</template>

<script>
import colors from '../../colors'

export default {
  name: 'MediaProgressTimeSlider',
  props: {
    duration: {
      type: Number,
      required: true,
    },
    currentTime: {
      type: Number,
    },
    timeRangePieces: {
      type: Array,
    },
  },
  data() {
    return {
      context: null,
      bufferCanvasWidth: 0,
      bufferCanvasHeight: 16,
      internalCurrentTime: this.currentTime,
    }
  },
  mounted() {
    this.bufferCanvasWidth = this.$refs.seekSlider.clientWidth
    this.context = this.$refs.bufferCanvas.getContext('2d')
  },
  updated() {
    this.redrawCanvas()
  },
  watch: {
    currentTime() {
      this.setInternalCurrentTime(this.currentTime)
      this.redrawCanvas()
    },
  },
  methods: {
    setInternalCurrentTime(currentTime) {
      this.internalCurrentTime = currentTime
    },
    onTimeSliderChange(event) {
      this.internalCurrentTime = event.target.valueAsNumber
      this.redrawCanvas()
      this.$emit('onTimeSliderChange', event)
    },
    redrawCanvas() {
      if (this.duration <= 0) {
        return
      }

      this.context.clearRect(
        0,
        0,
        this.$refs.bufferCanvas.width,
        this.$refs.bufferCanvas.height
      )

      const widthToDuration = this.$refs.bufferCanvas.width / this.duration
      const height = this.$refs.bufferCanvas.height

      // buffer bits
      this.timeRangePieces.forEach(timeRange => {
        const startX = Math.ceil(timeRange.start * widthToDuration)
        const endX = Math.ceil(timeRange.end * widthToDuration)
        const width = endX - startX

        this.context.fillStyle = colors.grayABitLighter
        this.context.fillRect(startX, 0, width, height)
      })

      // range-slider current time fill
      this.context.fillStyle = colors.mainColor
      this.context.fillRect(
        0,
        0,
        this.internalCurrentTime * widthToDuration,
        height
      )
    },
  },
}
</script>

<style lang="scss" scoped>
.media-progress-time-slider {
  position: relative;
  line-height: 0;
  margin-bottom: 0.5em;
}
.buffer-zone-canvas {
  width: calc(100% - 1rem);
  margin-left: 0.5rem;
  height: 0.5em;
  border-radius: 1em;

  background: $grayLighter;
}
.seek-slider {
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  display: block;
  width: 100%;
  max-width: none;
  transition: opacity 0.2s ease-in-out;
  -webkit-appearance: none;
  background-color: transparent;
  outline: none;

  //thumb
  &::-moz-range-thumb {
    opacity: 0;
    background-color: $mainColor;
  }

  &::-ms-thumb {
    opacity: 0;
    background-color: $mainColor;
  }

  &::-webkit-slider-thumb {
    transition: opacity 0.2s ease-in-out;
    opacity: 0;
    width: 1rem;
    height: 1rem;
    border-radius: 100%;
    background-color: $mainColor;
    cursor: pointer;
  }

  &:hover {
    &::-moz-range-thumb {
      opacity: 1;
    }

    &::-ms-thumb {
      opacity: 1;
    }

    &::-webkit-slider-thumb {
      transition: opacity 0.2s ease-in-out;
      opacity: 1;
    }
  }
}
</style>
